import React from 'react';
import Navbar from '../components/Navbar';
import DataTable from '../components/DataTable';

/* TO DO:
 * Create table and display all campaigns of Team Femr
 */

const CampaignsPage = () => {

  const campaignsColumns = ["Campaign", "Description", "Country", "City"];

  const campaignsData = [
    ["University of Toledo", null, "Haiti", "Marigot"],
    ["Global Response", null, "Mexico", "Matamoros"],
    ["ApParent Project", "Dr. Parson's group - primarily operates in Port Au Prince", 
    "United States", "New York"],
    ["Aid for Haiti", "Dr. Sutherland's group", "United States", "Tennessee"],
    ["WSU-WHSO", "Wayne State medical students", "United States", "Detroit"],
  ];

  /* DataTable component adheres to code re-use by passing in custom parameters
    (columns, data, route) when calling the component.
  */

  return (
    <div className="CampaignsPage">
        <Navbar/>
        <DataTable columns={campaignsColumns} data={campaignsData.map(c => c.map(x => x===null ? "N/A" : x))} route={"/campaign-metric"} title={"Campaigns Table"}/>
    </div>
  );
};

export default CampaignsPage;
